import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BloodtypeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"bloodtype"}/>
}
